import { LoginScreen } from "@/features/auth";

export default LoginScreen;
